export const extractProviderName = function(pluginID){
  return pluginID?.split('.')?.[1] || '';
}

export const extractPluginName = function(pluginID){
  return pluginID?.split('.')?.[2] || '';
}

export const extractAttributeName = function(valueKey){
  return valueKey?.startsWith('query.') 
    ? valueKey?.split('.')?.[1] || ''
    : valueKey?.split('.')?.[0] || '';
}

export const extractParameters = function(valueKey){
  return valueKey?.startsWith('query.') 
    ? valueKey?.split('.')?.slice(2) || []
    : valueKey?.split('.')?.slice(1) || [];
}

export const prettifyReportData = function(data){
  return data?.map((report) => {
    const dataTypeID = report.dataTypeID || report.pluginId;
    const values = report.values || report.value || {};

    return {
      dataTypeID: dataTypeID,
      timestamp: report.timestamp || Math.floor(Date.now()/1000),
      providerName: extractProviderName(dataTypeID),
      pluginName: extractPluginName(dataTypeID),
      values: Object.keys(values).map((valueKey) => {
        return {
          attrName: extractAttributeName(valueKey),
          parameters: extractParameters(valueKey),
          value: values[valueKey]
        }
      }),
    }
  }) || [];
}

export const prettifyAnalyticsPayload = function(payload){
  if(payload.type === 'viewed' || payload.type === 'engaged' && !payload.component){
    return [{
      dataTypeID: 'ctx.flybits.contentAnalytics',
      timestamp: payload.timestamp || Math.floor(Date.now()/1000),
      providerName: 'flybits',
      pluginName: 'contentAnalytics',
      values: [{
        attrName: payload.type,
        parameters: [payload.contentInfo.id],
        value: true
      }]
    }]
  } else if(payload.type === 'engaged' || payload.type === 'content_component_event' && payload.component){
    return [{
      dataTypeID: 'ctx.flybits.contentAnalytics',
      timestamp: payload.timestamp || Math.floor(Date.now()/1000),
      providerName: 'flybits',
      pluginName: 'contentAnalytics',
      values: [{
        attrName: 'componentEngaged',
        parameters: [payload.contentInfo.id, payload.component.id, payload.component.name, payload.component.compId],
        value: true
      }]
    }]
  }
  return [];
}